var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { StatisticsClient, IssuesClient, CompaniesClient, BatteryLifePredictionSettingsModel, IssueSettingsModel, CompanyServicesSettingsModel } from "@/app/api/battery-portal-api";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const statisticsClient = new StatisticsClient(window.apiUrl);
const issuesClient = new IssuesClient(window.apiUrl);
const companiesClient = new CompaniesClient(window.apiUrl);
let CompanySettingsVue = class CompanySettingsVue extends Vue {
    constructor() {
        super(...arguments);
        this.batteryLifePredictionSettingsModel = new BatteryLifePredictionSettingsModel();
        this.issueSettingsModel = new IssueSettingsModel();
        this.companyServicesSettingsModel = new CompanyServicesSettingsModel();
    }
    mounted() {
        this.getSettings();
    }
    getSettings() {
        this.loadBatteryLifePredictionSettings();
        this.loadIssuesSettings();
        this.loadCompanyServicesSettings();
    }
    loadBatteryLifePredictionSettings() {
        statisticsClient.getBatteryLifePredictionSettings(this.companyId)
            .then((response) => {
            if (response && response.length == 1) {
                this.batteryLifePredictionSettingsModel = response[0];
                this.setValues({
                    ohmicRiseLimitForBlockReplacement: this.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement,
                    percOfBlocksAboveOhmicRiseLimitForStringReplacement: this.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement,
                    minOhmicRiseToUsePrediction: this.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction,
                });
            }
        });
    }
    loadIssuesSettings() {
        issuesClient.getSettings(this.companyId)
            .then((response) => {
            if (response) {
                this.issueSettingsModel = response;
                this.setValues({
                    ohmicCriticalAlarmDescription: this.issueSettingsModel.ohmicCriticalAlarmDescription,
                    ohmicCriticalAlarmTask: this.issueSettingsModel.ohmicCriticalAlarmTask,
                    ambTempCriticalAlarmDescription: this.issueSettingsModel.ambTempCriticalAlarmDescription,
                    ambTempCriticalAlarmTask: this.issueSettingsModel.ambTempCriticalAlarmTask,
                });
            }
        });
    }
    loadCompanyServicesSettings() {
        companiesClient.getServicesSettings(this.companyId)
            .then((response) => {
            if (response)
                this.companyServicesSettingsModel = response;
        });
    }
    validateSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const { valid, errors } = yield this.validate();
            return valid;
        });
    }
    getBatteryLifePredictionSettings() {
        return this.batteryLifePredictionSettingsModel;
    }
    getIssueSettings() {
        return this.issueSettingsModel;
    }
    getCompanyServicesSettings() {
        return this.companyServicesSettingsModel;
    }
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get isAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanySettingsVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySettingsVue.prototype, "companyId", void 0);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySettingsVue.prototype, "getSettings", null);
CompanySettingsVue = __decorate([
    Component({
        name: "CompanySettingsVue",
        setup() {
            const { errors, validate, handleSubmit, defineInputBinds, setValues } = useForm({
                validationSchema: yup.object({
                    ohmicRiseLimitForBlockReplacement: yup.number().integer().min(1).max(100),
                    percOfBlocksAboveOhmicRiseLimitForStringReplacement: yup.number().integer().min(1).max(100),
                    minOhmicRiseToUsePrediction: yup.number().integer().min(1).max(100),
                    ohmicCriticalAlarmDescription: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ohmicCriticalAlarmTask: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ambTempCriticalAlarmDescription: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ambTempCriticalAlarmTask: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                }),
            });
            const ohmicRiseLimitForBlockReplacementVal = defineInputBinds('ohmicRiseLimitForBlockReplacement');
            const percOfBlocksAboveOhmicRiseLimitForStringReplacementVal = defineInputBinds('percOfBlocksAboveOhmicRiseLimitForStringReplacement');
            const minOhmicRiseToUsePredictionVal = defineInputBinds('minOhmicRiseToUsePrediction');
            const ohmicCriticalAlarmDescriptionVal = defineInputBinds('ohmicCriticalAlarmDescription');
            const ohmicCriticalAlarmTaskVal = defineInputBinds('ohmicCriticalAlarmTask');
            const ambTempCriticalAlarmDescriptionVal = defineInputBinds('ambTempCriticalAlarmDescription');
            const ambTempCriticalAlarmTaskVal = defineInputBinds('ambTempCriticalAlarmTask');
            return {
                errors,
                validate,
                handleSubmit,
                setValues,
                ohmicRiseLimitForBlockReplacementVal,
                percOfBlocksAboveOhmicRiseLimitForStringReplacementVal,
                minOhmicRiseToUsePredictionVal,
                ohmicCriticalAlarmDescriptionVal,
                ohmicCriticalAlarmTaskVal,
                ambTempCriticalAlarmDescriptionVal,
                ambTempCriticalAlarmTaskVal,
            };
        },
        expose: ["validateSettings", "getBatteryLifePredictionSettings", "getIssueSettings", "getCompanyServicesSettings"]
    })
], CompanySettingsVue);
export default CompanySettingsVue;
